import { render, staticRenderFns } from "./ExhibitionBlocks.vue?vue&type=template&id=87ff525a&scoped=true&"
import script from "./ExhibitionBlocks.vue?vue&type=script&lang=js&"
export * from "./ExhibitionBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionBlocks.vue?vue&type=style&index=0&id=87ff525a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ff525a",
  null
  
)

export default component.exports